const IconPlus = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 13H13L13 19H11L11 13H5L5 11H11L11 5H13L13 11H19L19 13Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconPlus;
